import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/activities')({
  component: () => <Navigate replace search to="/bo/activities" />,
})
